"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutConfirmDialog = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _common = require("../common");
var _jsxRuntime = require("react/jsx-runtime");
const TranslatedLogoutConfirmDialog = ({
  environment
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    eshopUrl
  } = (0, _configurationManager.useServiceUrls)([]);
  const {
    translations
  } = (0, _i18n.useTranslationsFromNamespace)();
  const config = (0, _react.useMemo)(() => JSON.stringify({
    DefaultLanguage: language,
    Translations: {
      // This is kind of logic that logout confirm dialog has
      // TODO (OL): Change logic in library? It would be better if it would preffer DefaultLanguage property instead or,
      // even better, if we could pass messages as is without diving it to language
      [typeof window !== 'undefined' && document.documentElement.lang || language]: translations
    }
  }), [language, translations]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "js-logout-data",
      "data-url-eshoplogout": eshopUrl ? `${eshopUrl}/iframe/internal/Services.aspx` : null
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.Spa, {
      environment: environment,
      rootAttributes: (0, _react.useMemo)(() => ({
        /* eslint-disable @typescript-eslint/naming-convention -- data attributes */
        'data-json-attributes': config
        /* eslint-enable @typescript-eslint/naming-convention */
      }), [config]),
      name: "logout-confirm-dialog"
    })]
  });
};
const LogoutConfirmDialog = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
  namespace: "logout-confirm-dialog",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TranslatedLogoutConfirmDialog, {
    ...props
  })
});
exports.LogoutConfirmDialog = LogoutConfirmDialog;
